module.exports = __webpack_public_path__ + "static/media/warning.289640f1.svg";